<style lang="scss">
	#bor{
		.lineChart {
			width: 100%;
			height: 13.9rem;
			display: inline-block;
			border: 2px solid #0c8b97;
			border-top: 0;
			/* box-shadow: 0 2px 12px 0 rgba(30,9,78, 1); */
		}	
	}
	
</style>

<template>
	<div style="height: 13.9rem;" id='bor'>
		<div class="lineChart Chart" :id="useData.id"></div>
	</div>
</template>
<script>
	export default {
		name: 'lineChart',
		props: ['dataBol', 'useData', 'widthPxMess'],
		data() {
			return {

			}
		},
		watch: {
			'dataBol': {
				handler(n) {
					// let _this = this;
					// if(n){
					//     let myChart = _this.$echarts.init(document.getElementById(_this.useData.id));
					//     _this.myChart = myChart;
					//     _this.drawChart();  
					// }
				}
			}
		},
		mounted() {
			let _this = this;
			// if(n){
			let myChart = _this.$echarts.init(document.getElementById(_this.useData.id));
			_this.myChart = myChart;
			_this.drawChart();
			
		},

		methods: {
			drawChart() {
				let _this = this;
				_this.myChart.setOption({
					// color: {
					//     type: 'linear',
					//     x: 0,
					//     y: 0,
					//     x2: 0,
					//     y2: 1,
					//     colorStops: [{
					//         offset: 0, color: 'red' // 0% 处的颜色
					//     }, {
					//         offset: 1, color: 'blue' // 100% 处的颜色
					//     }],
					//     global: false // 缺省为 false
					// },
					title: {
						text: '一分鐘(一日)',
						textStyle: {
							// color: '#ffffff',
							// fontWeight: 'bold',
							fontSize: _this.widthPxMess.titleSize,
						},
						x: '10',
						y: '10',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							animation: false
						}
					},
					grid: {
						// top: '25%',
						x: '10%',
						y: '25%',
						x2: '25%',
						y2: '25%',
						// borderWidth: 1
					},
					legend: {
						icon: 'none',
						textStyle: {
							color: '#045b8d', //'#a9a5b5',
							fontSize: _this.widthPxMess.XYSize
						},
						formatter: function() {
							return _this.useData.ckname
							// '貨幣單位：HKD(W)'
						},
						right: 20,
						top: '15%'
					},
					animation: true,
					xAxis: {
						data: ['9:30', '12:00', '16:00'],
						boundaryGap: false,
						axisTick: {
							show: false,
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: '#045b8d' //x文字
							}
						},
						axisLabel: {
							interval: 0,
							fontSize: _this.widthPxMess.XYSize
						}
					},
					yAxis: {
						nameTextStyle: {
							padding: [0, 30, 0, 0] // 四个数字分别为上右下左与原位置距离
						},
						data: ['63.750', '64.250', '64.750', '65.250', '66.000'],
						axisTick: {
							show: false,
						},
						 align:'center',
						// nameLocation:'middle',
						 position:'right',
						splitLine: {
							show: true,
							lineStyle: {
								color: '#ccc',
								type: 'dashed'
							}
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: '#045b8d',
							}
						},
						axisLabel: {
							fontSize: _this.widthPxMess.XYSize
						},
						// minInterval:1,
					},
					series: [{
						name: '模拟数据',
						type: 'line',
						smooth: true,
						showSymbol: false,
						hoverAnimation: false,
						itemStyle: {
							// color: '#36f3ff',
						},
						data: [65, 64.7, 64.3, 65, 64.3, 64.8]
					}]
				})
				
				// this.getcanvas()
			},
			// getcanvas(){
			// 	var canvas = document.getElementById(this.useData.id)
			// 	var ctr = canvas.getContext('2d');
			// 	ctr.fillStyle = '#fff';
			// 	ctr.fillRect(0,0,300,300)
			// }
		}
	}
</script>
